import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { FlatButton } from "src/framework/components/buttons/FlatButton";

import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { useObservable } from "src/framework/store/storeUtil";
import { vendedorInternoModalIsOpenedStore$ } from "src/store/vendas/projetos/store";
import { setVendedorInternoModalStatus } from "src/store/vendas/projetos/actions";
import { VendedorInternoModalStoreType } from "src/store/vendas/projetos/types";
import { Option } from "../../types";
import api from "src/framework/providers/api";
import { Conta } from "src/store/global.store.types";
import theme from "src/theme/light";
import { isLoading$ } from "src/framework/store/ApiEvents";

const VendedorInternoModal = () => {
  const modalStore = useObservable<VendedorInternoModalStoreType>(vendedorInternoModalIsOpenedStore$)

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [vendedoresOpts, setVendedoresOpts] = useState<Option<number>[]>([])
  const [vendedor, setVendedor] = useState<Option<number> | null>(null)

  useEffect(() => {
    api.get({
      url: "/cadastros/contas/vendedores_internos"
    }).then(res => {
      const data: Conta[] = res.data || []
      setVendedoresOpts(data.map(vendedor => {
        return {
          text: vendedor.nome,
          value: vendedor.id,
        }
      }))
      isLoading$.next(false);
    })
  },[])

  if (!modalStore?.status) return null;

  return (
    <Dialog
      open={modalStore.status || false}
      onClose={() => setVendedorInternoModalStatus(false)}
    >
      <DialogTitle>
        <Typography variant='h5' color='textPrimary'>
          Vincular vendedor interno
        </Typography>
        <Typography variant='body2' color='textSecondary'>
          Vincule um vendedor interno ao projeto.
        </Typography>
      </DialogTitle>

      <Box paddingBottom={2}>
        <Divider />
      </Box>

      <DialogContent style={{ width: isMobile ? "100%" : "500px" }}>

        <InputComboBoxList
          id={`vendedor-interno-list`}
          key={`vendedor-interno`}
          label={"Vendedor interno"}
          textField="text"
          valueField="value"
          options={vendedoresOpts}
          value={vendedor}
          autoComplete
          renderOptions={(option: any) => {
            return `${option.text}`
          }}
          renderOptionsLabel={(option: any) => {
            return `${option.text}`
          }}
          onChange={(value: any) => {
            setVendedor(value)
          }}
        />

      </DialogContent>
      <DialogActions>
        <FlatButton
          onClick={() => {
            isLoading$.next(true);
            modalStore?.onConfirm(vendedor || undefined)
            setVendedorInternoModalStatus(false)
          }}
          color="primary"
          variant="contained"
          text={"Salvar"}
        />
      </DialogActions>
    </Dialog>
  );
};

export { VendedorInternoModal };
